import {produce} from 'immer';
import moment from 'moment';

export const toggleArray = (array, value) => {

    //Prevent mutation
    return produce(array, (draft) => {

        let index = array.indexOf(value);

        if (index === -1) {
            draft.push(value);
        } else {
            draft.splice(index, 1);
        }
    });
};

export const groupBy = (xs, key) => {
    return xs.reduce((rv, x) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const handleNullDate = (date) => {
    return date ? moment(date) : null;
}